var map = {
	"./4dem.svg": 44700,
	"./activecampaign.svg": 82271,
	"./adobe-campaign.svg": 85892,
	"./amazon-simple-email-service-amazon-ses.svg": 55184,
	"./autopilot.svg": 66109,
	"./aweber.svg": 50062,
	"./birdeye.svg": 28986,
	"./brevo.svg": 55240,
	"./bronto-marketing-platform.svg": 45957,
	"./campaign-monitor.svg": 8606,
	"./constant-contact.svg": 79283,
	"./dotdigital-engagement-cloud.svg": 43001,
	"./elastic-email.webp": 97740,
	"./emarsys.svg": 89732,
	"./everest-formerly-250ok-and-return-path.svg": 11175,
	"./getresponse.svg": 24379,
	"./mail.svg": 37356,
	"./mailchimp.svg": 77086,
	"./mailerlite.svg": 60746,
	"./mailgun.svg": 1603,
	"./mailjet.webp": 7655,
	"./mailup.svg": 46507,
	"./marketo.svg": 75913,
	"./moosend.svg": 35670,
	"./outgrow.svg": 18483,
	"./pepipost-by-netcore.webp": 26332,
	"./sendgrid.svg": 36193,
	"./sendinblue.svg": 13095,
	"./sendpulse.svg": 46717,
	"./smtp2go.svg": 49704,
	"./twilio-sendgrid-email-api.svg": 29706,
	"./zoho-campaigns.svg": 6464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1529;